import { t } from 'lib-utils';

document.addEventListener('DOMContentLoaded', () => {
  const numElement = document.getElementById('number');
  const liveRegion = document.getElementById('countdown-text');
  const countdownContainer = document.querySelector('.countdown-timer');
 if (!numElement || !liveRegion) return;
 
 function parseISODate(dateText) {
  // Expecting format as "YYYY-MM-DD"
  const [year, month, day] = dateText.split('-').map(Number);
  if (!year || !month || !day) return null;
  return new Date(year, month - 1, day, 23, 59, 59);
 }
  
 const dateText = numElement.textContent.trim();
 const targetDate = parseISODate(dateText);

   if (isNaN(targetDate.getTime())) {
     numElement.textContent = 'Invalid date';
     console.error('Countdown: Invalid date parsed from', dateText);
     return;
   }

   function updateCountdown() {
     const now = new Date().getTime();
     let remaining = Math.floor((targetDate.getTime() - now) / 1000);

     if (remaining <= 0) {
       numElement.textContent = '00:00:00';
       const ended = t('sections.countdown_timer.ended');
       liveRegion.setAttribute('aria-label', ended);
       liveRegion.textContent = ended + ' ⌛️';
       clearInterval(timer);
       return;
     }

     const days = Math.floor(remaining / 86400);
     const hours = Math.floor((remaining % 86400) / 3600);
     const minutes = Math.floor((remaining % 3600) / 60);
     const seconds = remaining % 60;

     let newText;
     if (days >= 1) {
      const dayLabel = days > 1 ? t('sections.countdown_timer.days') : t('sections.countdown_timer.day');
      newText = `${days} ${dayLabel} ${hours.toString().padStart(2, '0')}h:${minutes
        .toString()
        .padStart(2, '0')}m:${seconds.toString().padStart(2, '0')}s`;
     } else {
       newText = `${hours.toString().padStart(2, '0')}h:${minutes
         .toString()
         .padStart(2, '0')}m:${seconds.toString().padStart(2, '0')}s`;
     }
     numElement.textContent = newText;
   }

   updateCountdown();
   const timer = setInterval(updateCountdown, 1000);
});
